<template>
  <v-text-field
    v-if="!vaqueiroSelecionado"
    density="compact"
    :label="labelInput"
    prepend-inner-icon="mdi-magnify"
    variant="outlined"
    v-model="txtBusca"
    @input="search(txtBusca)"
  />

  <v-list density="compact" v-if="vaqueiros.length > 0 && !vaqueiroSelecionado">
    <v-list-item
      v-for="vaqueiro in vaqueiros"
      :key="vaqueiro.id"
      :title="vaqueiro.nome"
      :subtitle="vaqueiro.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')"
      @click="selecionarVaqueiro(vaqueiro)"
    />
  </v-list>

  <div style="display: flex; line-height: 3px; justify-content: space-between" v-if="!vaqueiroSelecionado && vaqueiros.length === 0">
    <v-divider class="border-opacity-50" style="margin-right: 5px" />
    OU
    <v-divider class="border-opacity-50" style="margin-left: 5px" />
  </div>

  <v-form style="margin-top: 20px;" v-if="!vaqueiroSelecionado && vaqueiros.length === 0">

    <div style="margin: auto; width: fit-content" v-if="!formCadastro">
      <v-btn
        color="success"
        prepend-icon="mdi-account-plus"
        :text="actionTextButton"
        @click="formCadastro = true"
      />
    </div>

    <div v-if="formCadastro">
      <v-text-field
        v-model="dados.nome"
        density="compact"
        label="Nome"
        variant="outlined"
        :rules="[(v) => !!v || 'Nome é obrigatório']"
      />

      <v-text-field
        v-model="dados.cpf"
        v-mask="'###.###.###-##'"
        density="compact"
        label="CPF"
        variant="outlined"
        :rules="cpfRules"
      />

      <v-text-field
        v-model="dados.telefone"
        density="compact"
        label="Telefone"
        variant="outlined"
        v-mask="'(##) # ####-####'"
        :rules="[(v) => !!v || 'Telefone é obrigatório', (v) => v.length === 16 || 'Telefone deve ter 11 dígitos']"
      />

      <v-btn @click="salvar" color="success" prepend-icon="mdi-content-save" text="Cadastrar" />
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import { cpf } from 'cpf-cnpj-validator'
  import { mask } from 'vue-the-mask'
  import { useAppStore } from '@/stores/app'

  // @ts-ignore
  export default defineComponent({
    name: 'SelecionarVaqueiro',
    directives: { mask },
    data: () => ({
      txtBusca: '',
      store: useAppStore(),
      vaqueiros: [],
      vaqueiroSelecionado: null,
      formCadastro: false,
      cpfRules: [
        (v: string) => !!v || 'CPF é obrigatório',
        (v: string) => cpf.isValid(v) || 'CPF inválido'
      ],
      dados: {
        nome: '',
        cpf: '',
        telefone: ''
      }
    }),
    props: {
      labelInput: {
        type: String,
        required: true
      },
      actionTextButton: {
        type: String,
        default: 'Cadastrar-se'
      },
      zerarVaqueiro: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      async search(search: string) {
        if (search === '') return this.vaqueiros = [];
        try {
          const response = await this.axios
            .get(`users/search/${search}`);
          this.vaqueiros = response.data.users;
          this.putVaqueirosInCache();
        } catch (error) {
          console.error(error);
        }
      },
      putVaqueirosInCache() {
        this.store.setUsers(this.vaqueiros);
      },
      selecionarVaqueiro(vaqueiro: any) {
        this.vaqueiroSelecionado = vaqueiro;
        this.$emit('selecionarVaqueiro', vaqueiro);
        this.txtBusca = '';
        this.vaqueiros = [];
      },
      async salvar() {
        try {
          const dadosLocal = { ...this.dados };
          this.dados.cpf = this.dados.cpf.replace(/\D/g, '');
          this.dados.telefone = this.dados.telefone.replace(/\D/g, '');
          const response = await this.axios
            .post('users', this.dados);
          if (response.status === 201) {
            this.formCadastro = false;
            this.dados = {
              nome: '',
              cpf: '',
              telefone: ''
            };
            this.$emit('selecionarVaqueiro', {
              id: response.data.id,
              ...dadosLocal
            });
            this.store.addUser({
              id: response.data.id,
              ...dadosLocal
            })
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    emits: ['selecionarVaqueiro', 'update:zerarVaqueiro'],
    watch: {
      '$props.zerarVaqueiro' () {
        this.vaqueiroSelecionado = null;
        this.$emit('update:zerarVaqueiro', false);
      }
    }
  });
</script>

<style scoped>

</style>
